import { Box, Button, Dialog, Stack, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import { isDesktop } from "react-device-detect"
import { rqx } from "../../../../core/request/API"
import { domain, env } from "../../../../core/Env"
import { SnakeLoader } from "../../../../core/loader/SnakeLoader"
import { ToolContext } from "../../../../core/context/ToolContext"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import moment from "moment"
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export const Receipt = ({urlParams}) => {
    const { tool_state } = useContext(ToolContext)
    const { __SESSION } = tool_state
    const [receipt, setReceipt] = useState({data: null, loader: true})
    const history = useHistory()
    const handleLaunch = async() => {
        if (__SESSION.data.ainfo.account_type !== 2) {
            let ssoUrls = `${domain('psl').url}/sso/account/auth?ainfo=${encodeURI(JSON.stringify(__SESSION.data.ainfo))}`
            window.location.href = ssoUrls
        } else {
            let res = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/account/getlinkaccount`, {aid: __SESSION.data.ainfo.aid, mode: 'linkaccount'})
            if (res.length > 0) {
                let d = {account_type:res[0].account_type, aid:window.btoa(`account_${res[0].id}`), email:res[0].email, mobile_num:res[0].mobile_num, user_type:res[0].user_type, username:res[0].username}
                let ssoUrls = `${domain('psl').url}/sso/account/auth?ainfo=${encodeURI(JSON.stringify(d))}`
                window.location.href = ssoUrls
            } else {
                let ssoUrls = process.env.REACT_APP_URL_TOOL_PSL+'/switching/select'
                window.location.href = ssoUrls
            }
        }
    }

    const DataRow = ({label, value}) => (
        <Stack direction="row" justifyContent="space-between" borderBottom="1px dashed #ccc" paddingBottom={0.5}>
            <Typography fontSize={{xs: 14, md: 16}} color="#333333">
                {label}
            </Typography>
            <Typography fontSize={{xs: 14, md: 16}} color="#1976D2" fontWeight={600}>
                {value}
            </Typography>
        </Stack>
    )

    const glbUserMembership = async(data) => {
        // Parse the transaction date
        const transactionDate = new Date(data.order_data[0].transaction_date);
        
        // Add the validity period (in months)
        const expirationDate = new Date(transactionDate);
        expirationDate.setMonth(expirationDate.getMonth() + data.membership_info[0].validity);

        // Format to YYYY-MM-DD
        const pad = (n) => (n < 10 ? '0' + n : n);
        const formattedExpiration = 
            `${expirationDate.getFullYear()}-${pad(expirationDate.getMonth() + 1)}-${pad(expirationDate.getDate())}`;

        const body ={
            aid: __SESSION.data.ainfo.aid,
            org_owner_aid: window.btoa(`account_${data.membership_info[0].owner_id}`),
            company_id: __SESSION.data.uaccess?.[0]?.company_id === null ? 0 : __SESSION.data.uaccess?.[0]?.company_id,
            membership_id: data.membership_info[0].membership_id,
            order_id: data.order_data[0].order_id,
            expiration:formattedExpiration
        }
        const res = await rqx.post(`<<global>>/${env() === "local" ? "dev" : env()}/membership/create`, body)
        if (res) {
            localStorage.removeItem('membership')
        }
    }

    const handleTryAgain = () => {
        history.push(`/psl/membership?steps=pay&id=${window.btoa(receipt.data.membership_id)}`)
    }
    
    useEffect(() => {
        try {
            setReceipt((p) => (
                {...p, loader: true}
            ))
            const membershipReceipt = async() => {
                let params;
                if (urlParams.get('type')) {
                    if (urlParams.get('type') === 'free') {
                        params = {
                            order_id: window.atob(urlParams.get('order_id')),
                            membership_id: window.atob(urlParams.get('id')),
                        }
                    }
                }else{
                    params = {
                        order_id: JSON.parse(urlParams.get('param2')).oid,
                        membership_id: JSON.parse(urlParams.get('param2')).membership_id,
                    }
                }
                const rec = await rqx.get(`<<tool>>/${env()}/membership/receipt`, { order_id: params.order_id, membership_id: params.membership_id })
                if (rec) {
                    glbUserMembership(rec)
                    const receipt_info = {
                        ...rec.order_data[0],
                        ...rec.membership_info[0],
                        inclusion: rec.inclusions,
                    }
                    setReceipt((p) => (
                        {...p, data: receipt_info, loader: false}
                    ))
                }else{
                    localStorage.removeItem('membership')
                }
            }
            membershipReceipt()
        } catch (error) {
            console.error('Failed to fetch membership receipt:', error)
        }
        // eslint-disable-next-line
    },[])

    return(
        <Dialog open={true} fullScreen={!isDesktop ? true : false}>
            { receipt.loader ? 
                <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center">
                    <SnakeLoader bg="#256EFF" size="12px" distance="7px" sx={{ mt: '1rem' }}/>
                </Box>
            :   
                receipt.data === null ?
                    <Box height="100vh" display="flex" justifyContent="center" alignItems="center">
                        <Box textAlign="center">
                            <ErrorOutlineIcon color="error" sx={{fontSize: 50}} />
                            <Box
                            sx={{
                                fontSize: { xs: '18px', sm: '20px', md: '24px' },
                                fontWeight: 'bold',
                                marginBottom: { xs: '8px', sm: '12px' },
                                color: '#D32F2F', // red tone to indicate error
                            }}
                            >
                            Payment Unsuccessful
                            </Box>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleTryAgain}
                            // onClick={handleRetryPayment}
                            >
                            Try Again
                            </Button>
                        </Box>
                    </Box>
                :
                <>
                    <Box height="100%" width="100%" p="1rem" display="flex" flexDirection="column" gap="1.5rem" className="overflowY">
                        <Typography variant="subtitle1" fontWeight={700} textAlign="center">Thank you!</Typography>
                        <Typography variant="h6" fontWeight={600} textAlign="center">Membership Payment Confirmation</Typography>
                        {/* <Typography variant="subtitle1" fontWeight={500} > 
                            <b>Membership Name:</b> {receipt.data.name}
                        </Typography> */}
                        <Stack width="100%" spacing={2}>
                            <DataRow label="Transaction Date:" value={moment(receipt.data.transaction_date).format('MM/DD/YYYY')} />
                            {
                                receipt.data.fee_type === 2 &&
                                    <>
                                        <DataRow label="Reference No:" value={receipt.data.reference_number} />
                                        <DataRow label="Pay Via:" value={receipt.data.payment_channel_id === 7 ? "GCash" : "Union Bank"} />
                                        <DataRow label="Total Amount Paid:" value={`P ${receipt.data.amount}`} />
                                    </>
                            }
                            <DataRow label="Contact No:" value={`+63 ${receipt.data.contact_number}`} />
                            <DataRow label="Name:" value={receipt.data.first_name} />
                            <DataRow label="Email:" value={receipt.data.email} />
                            <DataRow label="Membership Name:" value={receipt.data.name} />
                            
                            <DataRow label="Membership Validity:" value={`${receipt.data.validity} Month${receipt.data.validity > 1 && 's'}`} />
                            <Typography fontSize={{xs: 14, md: 16}} color="#333333">
                                Membership
                            </Typography>
                            <ul>
                                {
                                    receipt.data.inclusion.map((v,k) => (
                                        <li style={{fontSize: 14}} key={k}> 
                                            {v.name}
                                        </li>
                                    ))
                                }
                               
                            </ul>
                            <Typography fontSize={12} fontWeight={400} textAlign="center" color="#5B6167">Copy of your transaction receipt and Details regarding the training has been sent to your email.</Typography>
                        </Stack>
                    </Box>
                    <Box p="1rem" borderTop="1px solid #0000001f" display="flex" justifyContent="center">
                        <Button variant="contained" fullWidth onClick={handleLaunch}>
                            Launch to POFI
                        </Button>
                    </Box>
                </>
            }
        </Dialog>
    )
}